export default "__VITE_ASSET__BQh2lGHA__"